import React, { Component } from "react";
import { Button, Form, Image } from "react-bootstrap";
import { toast } from "react-toastify";
import configData from "../config.json";
import "./Abha.css";
export default class Abhaaddressprofile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requestId: sessionStorage.getItem("requestId"),
      AbhaProfile: { mobileNumber: "" },
      abhanumber: "",
      aadharNumber: "",
      isSubmitting: false,
      getAbhaQrCode: false,
      qrCodePaths: [],
      isSubmittingQrcode: false,
      updateprofile: false,
      mobileNumberNumber: "",
      emailId: "",
      address: "",
    };
  }
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.success(msg);
    }
  };

  componentDidMount() {
    this.ResponseHandler();
    const nonKycFlag = sessionStorage.getItem("nonKycFlag");
  const toastShown = sessionStorage.getItem("toastShown");

  if (nonKycFlag === "1" && toastShown !== "true") {
    sessionStorage.setItem("toastShown", "true");
    setTimeout(() => {
      this.showToast(
        "This is a non-KYC ABHA address. Please link your ABHA address to your ABHA number to enable download.",
        "error"
      );
    }, 3000); // 5 sec delay
  }
  }
  ResponseHandler = () => {
    var formData = new FormData();

    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhaaddress/retriverequestId", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" && data.detail) {
          const abhaProfile = data.detail;
          console.log(abhaProfile);

          if (abhaProfile) this.setState({ AbhaProfile: abhaProfile });
        
        }
      
      });
  };
  HandleClick = () => {
    this.setState({ isSubmitting: true });
    var formData = new FormData();
    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhaaddress/retriveAbhacard", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message);
        if (data.status === "success") {
          this.handleDownloadPng(data.details);
        }
        this.setState({
          isSubmitting: false,
        });
      });
  };
  HandleQrcodeClick = () => {
    this.setState({ getAbhaQrCode: true });

    const formData = new FormData();
    formData.append("requestId", this.state.requestId);

    fetch(configData.api_url + "C_Abhaaddress/getAbhaQrCode", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message);
        if (data.status === "success") {
          this.handleDownloadPng(data.details); // assuming this method handles showing or downloading the QR code
        }
        this.setState({ isSubmitting: false });
      })
      
  };

handleDownloadPng = async (url) => {
 
  try {
    
    const requestId = sessionStorage.getItem("requestId") || "file";

    // Fetch file as blob
    const response = await fetch(url);
    if (!response.ok) throw new Error("Network response was not ok");

    const blob = await response.blob();

    // Create temporary URL
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;

    // Preserve file extension from blob type
    const ext = blob.type.split("/")[1] || "png"; // fallback
    link.download = `${requestId}.${ext}`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Release memory
    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error("Download failed:", error);
  }
};
  handlenextClick = () => {
    window.location.href = "/abhaverification";
  };
  HandleABHAVerificationClick = () => {
    sessionStorage.setItem("abhanumber", this.state.AbhaProfile.abhanumber);
    window.location.href = "/abhaverification";
  };

  HandleUPClick = () => {
    window.location = "./updateprofileabha";
  };
  handlenewClick = () => {
    sessionStorage.setItem("abhaAddress", 
      this.state.AbhaProfile.phrAddress);
    window.location = "./abhacreationan";
  };
  render() {
    return (
      <div>
        {/* <div className="row mb-2" id="flowStyle">
          <div className="col-md-3 flowTab Inactive">
            <div className="widget_BG widget_BG_grid bi bi-collection nav-icon">
              <p className="nav-label mt-2">Consent Collection</p>
            </div>
          </div>

          <div className="col-md-3 flowTab Inactive">
            <div className="widget_BG widget_BG_grid bi bi-file-richtext nav-icon">
              <p className="nav-label mt-2">mobileNumber Authentication</p>
            </div>
          </div>
          <div className="col-md-3 flowTab Inactive">
            <div className="widget_BG widget_BG_grid bi bi-file-person nav-icon">
              <p className="nav-label mt-2">ABHA verification</p>
            </div>
          </div>
          <div className="col-md-3 flowTab active-page">
            <div className="widget_BG widget_BG_grid bi bi-info-square nav-icon">
              <p className="nav-label mt-2">Profile Collection</p>
            </div>
          </div>
        </div> */}

        <div className="row widget_BG widget_BG_grid d-flex m-0 mt-2">
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Form.Group>
              <Form.Label>First Name</Form.Label>
              <Form.Control
                type="text"
                name="firstName"
                id="firstName"
                disabled
                value={this.state.AbhaProfile.firstName}
                className="form-control"
              />
            </Form.Group>
          </div>
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Form.Group>
              <Form.Label>Middle Name</Form.Label>
              <Form.Control
                type="text"
                name="middleName"
                id="middleName"
                disabled
                value={this.state.AbhaProfile.middleName}
                className="form-control"
              />
            </Form.Group>
          </div>
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Form.Group>
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type="text"
                name="lastName"
                id="lastName"
                value={this.state.AbhaProfile.lastName}
                disabled
                className="form-control"
              />
            </Form.Group>
          </div>

          <div className="col-md-4 abhaprofilediv datepick">
            <Form.Group>
              <Form.Label>Date Of Birth</Form.Label>

              <div ClassName="custom-calendar">
                <Form.Control
                  type="text"
                  name="dob"
                  id="dob"
                  value={this.state.AbhaProfile.dob}
                  disabled
                  className="form-control"
                />
              </div>
            </Form.Group>
          </div>
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Form.Group controlId="policyType">
              <Form.Label>Gender</Form.Label>
              <Form.Control
                as="select"
                disabled
                value={this.state.AbhaProfile.gender}
                onChange={this.handlegenderchange}
              >
                <option value="">Select</option>
                <option value="M">Male</option>
                <option value="F">Female</option>
                <option value="Tr">Transgender</option>
              </Form.Control>
            </Form.Group>
          </div>
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Form.Group>
              <Form.Label>Mobile Number</Form.Label>
              <Form.Control
                type="text"
                name="mobileNumber"
                id="mobileNumber"
                maxLength={10}
                value={this.state.AbhaProfile.mobileNumber}
                disabled
              />
            </Form.Group>
          </div>

          <div className="col-md-4 abhaprofilediv datepick">
            <Form.Group>
              <Form.Label>ABHA Number</Form.Label>

              <div ClassName="custom-calendar">
                <Form.Control
                  type="text"
                  name="abhanumber"
                  id="abhanumber"
                  value={this.state.AbhaProfile.abhanumber}
                  disabled
                  className="form-control"
                />
              </div>
            </Form.Group>
          </div>
          <div className="col-md-4 abhaprofilediv datepick">
            <Form.Group>
              <Form.Label>ABHA Address</Form.Label>

              <div ClassName="custom-calendar">
                <Form.Control
                  type="text"
                  name="phrAddress"
                  id="phrAddress"
                  value={this.state.AbhaProfile.phrAddress}
                  disabled
                  className="form-control"
                />
              </div>
            </Form.Group>
          </div>
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Image
              style={{
                width: "100px",
                marginLeft: "5px",
                marginTop: "10px",
              }}
              src={"data:image/jpeg;base64," + this.state.AbhaProfile.photo}
              alt="image"
            ></Image>
          </div>
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Form.Group>
              <Form.Label>Email-Id</Form.Label>
              <Form.Control
                type="text"
                name="email"
                id="email"
                value={this.state.AbhaProfile.emailId}
                disabled
              />
            </Form.Group>
          </div>
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Form.Group>
              <Form.Label>Address</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="address"
                id="address"
                value={this.state.AbhaProfile.address}
                disabled
              />
            </Form.Group>
          </div>
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Form.Group>
              <Form.Label>Pincode </Form.Label>
              <Form.Control
                type="text"
                name="pinCode"
                id="pinCode"
                maxLength={6}
                value={this.state.AbhaProfile.pinCode}
                disabled
              />
            </Form.Group>
          </div>
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Form.Group>
              <Form.Label>District</Form.Label>
              <Form.Control
                type="text"
                name="districtName"
                id="districtName"
                maxLength={10}
                value={this.state.AbhaProfile.districtName}
                disabled
              />
            </Form.Group>
          </div>
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Form.Group>
              <Form.Label>State</Form.Label>
              <Form.Control
                type="text"
                name="stateName"
                id="stateName"
                value={this.state.AbhaProfile.stateName}
                disabled
              />
            </Form.Group>
          </div>
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Form.Group>
              <Form.Label>ABHA Status</Form.Label>

              {this.state.AbhaProfile.abhaStatus === "ACTIVE" ? (
                <i
                  className="bi bi-check"
                  style={{
                    color: "green",
                    fontSize: "50px",
                    marginLeft: "5px",
                  }}
                ></i>
              ) : this.state.AbhaProfile.abhaStatus === "INACTIVE" ? (
                <i
                  className="bi bi-x"
                  style={{
                    color: "red",
                    fontSize: "1.2rem",
                    marginLeft: "5px",
                  }}
                ></i>
              ) : null}
            </Form.Group>
          </div>
        </div>
        <div className="row  widget_BG widget_BG_grid m-0 mt-2">
          <div className="col text-end">
             {/* <Button className="rounded-0 m-1" onClick={this.handlenewClick}>
                        New ABHA Address
                      </Button>
          
            <Button className="rounded-0 m-1" onClick={this.HandleUPClick}>
              Update Profile
            </Button> */}
            <Button
              className="rounded-0 m-1"
              onClick={this.HandleQrcodeClick}
              disabled={this.state.getAbhaQrCode}
            >
              {this.state.getAbhaQrCode ? "Fetching..." : "Get ABHA QR Code"}
            </Button>

            <Button
              className="rounded-0 m-1"
              disabled={this.state.isSubmitting}
              onClick={this.HandleClick}
            >
              {this.state.isSubmitting
                ? "Downloading ABHA Card..."
                : "Download ABHA  "}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}





